export default __webpack_public_path__ + "static/media/logo-tran.b1608c34.png";